<template>
  <Form
    ref="form"
    :model="formData"
    :inline="inline"
    label-position="top"
    :class="{ 'disabled-valid': !valid }"
  >
    <template v-for="(item, key) in model">
      <FormItem
        v-if="!item.isHidden"
        :key="key"
        :prop="key"
        :label="item.label ? item.label : ''"
        :rules="valid ? item.rules : []"
      >
        <Input
          v-if="item.type === 'input'"
          v-model="formData[key]"
          v-bind="item.props"
          :disabled="item.disabled"
          :placeholder="`请输入${item.placeholder || item.label}`"
          @on-search="(value) => item.onSearch(value)"
        />
        <InputNumber
          style="width: 100%"
          v-if="item.type === 'number'"
          v-model="formData[key]"
          :disabled="item.disabled"
          :placeholder="`请输入${item.label}`"
          :precision="item.precision"
          :max="item.max"
          :min="item.min"
          :active-change="false"
          @on-change="
            (value) => {
              if (item.onChange) item.onChange(value)
            }
          "
        />
        <Input
          v-if="item.type === 'textarea'"
          type="textarea"
          v-model="formData[key]"
          :disabled="item.disabled"
          :placeholder="`请输入${item.label}`"
          :maxlength="item.maxlength"
          :show-word-limit="item.disabled ? false : true"
        />
        <RichText
          v-if="item.type === 'richtext'"
          v-model="formData[key]"
          :disabled="item.disabled"
          :placeholder="`请输入${item.label}`"
        />
        <!-- {{ item.isHidden }}
        {{ formData[key] }} -->
        <Select
          v-if="item.type === 'select'"
          v-model="formData[key]"
          :style="{ minWidth: '150px' }"
          :max-tag-count="2"
          :disabled="item.disabled"
          :multiple="item.multiple"
          :filterable="item.filterable"
          :loading="item.loading"
          :placeholder="item.placeholder ? item.placeholder : `请选择${item.label}`"
          :remote-method="item.remoteMethod"
          @on-change="
            (value) => {
              if (item.onChange) item.onChange(value, model)
            }
          "
        >
          <template v-for="option in item.options">
            <OptionGroup
              v-if="option.children && option.children.length > 0"
              :label="option.label"
              :key="option.value"
            >
              <Option
                v-for="item in option.children"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </OptionGroup>
            <Option v-else :key="option.value" :value="option.value">{{
              option.label
            }}</Option>
          </template>
        </Select>
        <Cascader
          v-if="item.type === 'cascader'"
          :placeholder="`请选择${item.label}`"
          :data="item.data"
          @on-change="
            (value) => {
              formData[key] = value[value.length - 1]
            }
          "
        />
        <RadioGroup
          v-if="item.type === 'radio'"
          v-model="formData[key]"
          @on-change="
            (value) => {
              if (item.onChange) item.onChange(value)
            }
          "
        >
          <Radio
            v-for="radio in item.options"
            :label="radio.value"
            :key="radio.value"
            >{{ radio.label }}</Radio
          >
        </RadioGroup>
        <Transfer
          v-if="item.type === 'transfer'"
          :data="item.options"
          :target-keys="item.value"
          @on-change="
            (newTargetKeys) => {
              transferOnChange(key, item, newTargetKeys)
            }
          "
        ></Transfer>
        <Areas
          v-if="item.type === 'areas'"
          v-model="formData[key]"
          :max="item.max"
          :placeholder="`请选择${item.label}`"
        ></Areas>
        <AreasTree
          v-if="item.type === 'areasTree'"
          v-model="formData[key]"
          :max="item.max"
        ></AreasTree>
        <Objects
          v-if="item.type === 'objects'"
          v-model="formData[key]"
          :value-dic="item.valueDic"
          :max="item.max"
          :rules="item.rules"
        ></Objects>
        <Specs
          v-if="item.type === 'specs'"
          v-model="formData[key]"
          :spec-type.sync="item.specType"
          :specs-variable="item.specsVariable"
          :skus.sync="item.skus"
          :extra-specs.sync="item.extraSpecs"
          :options="item.options"
          :max="item.max"
          :disabled="item.disabled"
        ></Specs>
        <DatePicker
          v-if="item.type === 'date'"
          :value="formData[key]"
          format="yyyy-MM-dd"
          type="date"
          :style="{ width: '100%' }"
          :disabled="item.disabled"
          :placeholder="`请选择${item.label}`"
          :options="item.options"
          :start-date="item.startDate"
          @on-change="
            (value) => {
              formData[key] = value
            }
          "
        ></DatePicker>
        <DatePicker
          v-if="item.type === 'datetime'"
          :value="formData[key]"
          format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          :style="{ width: '100%' }"
          :disabled="item.disabled"
          :placeholder="`请选择${item.label}`"
          :options="item.options"
          @on-change="
            (value) => {
              formData[key] = value
            }
          "
        ></DatePicker>
        <DatePicker
          v-if="item.type === 'datetimerange'"
          :style="{ width: '100%' }"
          :value="formData[key]"
          v-model="formData[key]"
          format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          :disabled="item.disabled"
          :placeholder="`请选择${item.label}`"
          :options="item.options"
          @on-change="
            (value) => {
              formData[key] = value
            }
          "
        ></DatePicker>
        <DatePicker
          v-if="item.type === 'dateRange'"
          :value="isResert ? [] : formData[key]"
          format="yyyy-MM-dd"
          type="daterange"
          :disabled="item.disabled"
          :style="{ width: '100%' }"
          :placeholder="item.placeholder ? item.placeholder : `请选择${item.label}`"
          @on-change="
            (value) => {
              formData[key] = value
            }
          "
        ></DatePicker>
        <t-date-range-picker
          v-if="item.type === 'monthRange'"
          :value="formData[key]"
          mode="month"
          v-model="formData[key]"
          :disabled="item.disabled"
          :style="{ width: '100%' }"
          :placeholder="item.placeholder ? item.placeholder : `请选择${item.label}`"
          clearable
          @on-change="
            (value) => {
              formData[key] = value
            }
          "
        ></t-date-range-picker>
        <i-switch
          v-if="item.type === 'switch'"
          v-model="formData[key]"
          :disabled="item.disabled"
          :true-value="item.trueValue"
          :false-value="item.falseValue"
          @on-change="
            (value) => {
              if (item.onChange) item.onChange(value)
            }
          "
        />
        <Calendar
          v-if="item.type === 'calendar'"
          v-model="formData[key]"
          :field-model="item"
        ></Calendar>
        <Workteam
          v-if="item.type === 'workteam'"
          v-model="formData[key]"
          :field-model="item"
        ></Workteam>
        <XUpload
          v-if="item.type === 'upload'"
          v-model="formData[key]"
          :field-model="item"
          :folder="item.folder"
          :disabled="item.disabled"
          :desc="item.desc || []"
        ></XUpload>
        <span v-if="item.historyValue" class="field-desc"
          >历史：{{ item.historyValue }}</span
        >
      </FormItem>
    </template>
    <slot></slot>
    <FormItem>
      <div class="handler-buttons">
        <slot name="button" :form-data="formData"></slot>
      </div>
    </FormItem>
  </Form>
</template>
<style lang="stylus" scoped>
.disabled-valid
  display: flex
  align-items: flex-end
  width: 100%
  flex-wrap: wrap
  >>>.ivu-form-item
    margin-right: 12px
    margin-bottom: 10px
    min-width: calc(20% - 12px)

.field-desc
  margin-left: 10px
  color: #999
>>>.handler-buttons    
    display: flex
    > *
      margin-right: 8px
</style>
<script>
import Areas from './Areas'
import AreasTree from './AreasTree'
import Calendar from './Calendar'
import Workteam from './Workteam'
import XUpload from './Upload'
import Objects from './Objects'
import Specs from './specs/'
import RichText from './RichText'
export default {
  components: {
    Areas,
    AreasTree,
    Calendar,
    XUpload,
    Objects,
    Specs,
    Workteam,
    RichText,
  },
  props: {
    model: Object,
    inline: Boolean,
    label: Boolean,
    valid: Boolean,
    extendData: Object,
  },
  data() {
    return {
      formData: {},
      unWatch: [],
      isResert: false,
    }
  },
  provide() {
    return {
      formData: this.formData,
    }
  },
  watch: {
    model: {
      handler(newValue) {
        // 每次模型更新都要先取消前一个模型的观察函数
        this.destroyWatch()
        if (JSON.stringify(newValue) === '{}') {
          this.formData = {}
        } else {
          for (let key in newValue) {
            const value = newValue[key].deep
              ? newValue[key].value || this.formData[key]
              : this.formData[key] || newValue[key].value // 模型更新时优先取已设置的值，当没有设置时取模型里的默认值。
            this.$set(this.formData, key, value)
            const watch = newValue[key].watch
            if (watch) {
              this.buildWatch(watch)
            }
          }
        }
      },
      deep: true, // !深度跟踪表单模型变化
      immediate: true,
    },
  },
  methods: {
    validate() {
      this.isResert = false
      return this.$refs.form.validate()
    },
    resetFields() {
      this.isResert = true
      setTimeout(() => {
        if(this.isResert  == true) {
          this.isResert = false
        }
      }, 1000)
      return this.$refs.form.resetFields()
    },
    buildWatch(watch) {
      for (let key in watch) {
        this.unWatch.push(
          this.$watch(`formData.${key}`, function (_newValue, _oldValue) {
            if (_newValue !== _oldValue) {
              watch[key](this.formData)
            }
          })
        )
      }
    },
    destroyWatch() {
      this.unWatch.forEach((fn) => fn())
      this.unWatch = []
    },
    transferOnChange(formKey, formItem, newTargetKeys) {
      this.formData[formKey] = newTargetKeys
      formItem.value = newTargetKeys
    },
    getData() {
      return this.formData
    },
  },
}
</script>
